<div class="block-screen"></div>

<div class="popup-container" (click)="clickBackgroundClose()">
  <div
    class="popup"
    (click)="stopPropagation($event)"
    [style.height]="popupHeight"
    [style.width]="popupWidth"
  >
    <button [appButton]="'ghost'" class="btn-icon close-icon" (click)="handleClose()">
      <fa-icon [icon]="faXmark" [size]="'2x'"></fa-icon>
    </button>

    <div class="title">
      <h1 *ngIf="config.title">{{ config.title | translate }}</h1>
    </div>

    <div class="content">
      <div class="absolute-container">
        <ng-content></ng-content>
      </div>
    </div>

    <div class="button-container">
      <button *ngIf="config.showNextButton" [appButton]="'primary'" (click)="next()">
        {{ config.nextButtonText | translate }}
      </button>

      <button *ngIf="config.showBackButton" [appButton]="'ghost'" (click)="back()">
        {{ config.backButtonText | translate }}
      </button>
    </div>
  </div>
</div>
